import { render, staticRenderFns } from "./ProviderField.vue?vue&type=template&id=50b168da&"
import script from "./ProviderField.vue?vue&type=script&lang=js&"
export * from "./ProviderField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/projects/releases/338/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50b168da')) {
      api.createRecord('50b168da', component.options)
    } else {
      api.reload('50b168da', component.options)
    }
    module.hot.accept("./ProviderField.vue?vue&type=template&id=50b168da&", function () {
      api.rerender('50b168da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/pages/components/fields/ProviderField.vue"
export default component.exports